import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer style={{ backgroundColor: 'var(--secondary-color)', color: 'white', padding: '4rem 0' }}>
            <div className="container">
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem' }}>
                    <div>
                        <h3>2ATP-MR</h3>
                        <p style={{ marginTop: '1rem', color: '#94a3b8' }}>
                            Service de transport conventionné en Ile de France. Transport PMR, scolaire, et privé.
                        </p>
                    </div>
                    <div>
                        <h4>Liens Rapides</h4>
                        <ul style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <li><Link to="/">Accueil</Link></li>
                            <li><Link to="/services">Services</Link></li>
                            <li><Link to="/fleet">Notre Flotte</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4>Contact</h4>
                        <ul style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem', color: '#94a3b8' }}>
                            <li>contact@2atp-mr.com</li>
                            <li>01 30 22 47 00</li>
                            <li>68-70 rue Aristide Briand, 78130 Les Mureaux</li>
                        </ul>
                    </div>
                </div>
                <div style={{ borderTop: '1px solid #334155', marginTop: '3rem', paddingTop: '1.5rem', textAlign: 'center', color: '#64748b' }}>
                    <p>&copy; {new Date().getFullYear()} 2ATP-MR. Tous droits réservés.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
